import jQuery from "../modules/jquery/jquery-3.6.1.min.js"
(function($) {
	var menu = {
		removeClasses: function($clicked) {
			$('body').removeClass('menu-open');
			$('#' + $clicked.data('id') + ', .menu-toggle').attr('aria-expanded', 'false');
		},
		addClasses: function($clicked) {
			$('body').addClass('menu-open');
			$('#' + $clicked.data('id') + ', .menu-toggle').attr('aria-expanded', 'true');
		},
		menuToggle: function(e) {
			if ($(this).hasClass('menu-toggle-close')) {
				menu.removeClasses($(this));
			} else {
				menu.addClasses($(this));
			}
		},
		init: function() {
			$('.menu-toggle').on('click', this.menuToggle);
		}
	}

	var dropdown = {
		removeClasses: function($clicked) {
			$clicked.attr('aria-expanded', 'false');
			$clicked.removeClass('toggled-on');
			$clicked.next('.sub-menu').removeClass('toggled-on');
		},
		addClasses: function($clicked) {
			$clicked.attr('aria-expanded', 'true');
			$clicked.addClass('toggled-on');
			$clicked.next('.sub-menu').addClass('toggled-on');
		},
		dropdownToggle: function(e) {
			if ($(this).hasClass('toggled-on')) {
				dropdown.removeClasses($(this));
			} else {
				dropdown.addClasses($(this));
			}
		},
		init: function() {
			$('.dropdown-toggle').on('click', this.dropdownToggle);
		}
	}

	$(document).ready(function() {
		$(".menu-item-has-children .sub-menu").before('<button class="dropdown-toggle" aria-expanded="false"><span class="screen-reader-text"></span></button>');
		menu.init();
		dropdown.init();

	});
})(jQuery);